// @ts-strict-ignore
import {Component, HostBinding, inject, input, output} from "@angular/core";
import {AdministrationTableService} from "../administration-table.service";
import {IId} from "@models";
import {Translations} from "@translations";
import {BulkAction} from "../../basic-administration-table-page/administration-table-page.types";

@Component({
	selector: "sim-administration-table-bulk-actions",
	templateUrl: "./administration-table-bulk-actions.component.html",
	styleUrl: "./administration-table-bulk-actions.component.scss",
	standalone: false,
})
export class AdministrationTableBulkActionsComponent<T extends IId> {
	@HostBinding("class.showing") get showing() {
		return this._stateService.isSomeSelected();
	}

	protected readonly T = Translations;
	private _stateService = inject<AdministrationTableService<T>>(AdministrationTableService);

	public bulkActions = input<BulkAction[]>([
		{
			methodName: "bulkDelete",
			displayNameTranslationKey: this.T.SHARED_BASIC_ADMINISTRATION_TABLE_DELETE,
			value: "delete",
		},
	]);

	public selectedBulkAction: BulkAction["value"] | null = null;

	public bulkActionClicked = output<{type: BulkAction["value"]; values: T[]}>();

	protected executeBulkAction() {
		this.bulkActionClicked.emit({
			type: this.selectedBulkAction,
			values: this._stateService.selection,
		});
	}
}
